import { SVGProps } from 'react'

export const IconUpArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="10"
    viewBox="0 0 18 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9424 9.19236C16.8843 9.25056 16.8153 9.29674 16.7394 9.32825C16.6635 9.35976 16.5821 9.37598 16.4999 9.37598C16.4177 9.37598 16.3362 9.35976 16.2603 9.32825C16.1844 9.29674 16.1154 9.25056 16.0574 9.19236L8.99986 2.13361L1.94236 9.19236C1.88425 9.25047 1.81526 9.29657 1.73934 9.32802C1.66341 9.35946 1.58204 9.37565 1.49986 9.37565C1.41768 9.37565 1.3363 9.35946 1.26038 9.32802C1.18446 9.29657 1.11547 9.25047 1.05736 9.19236C0.99925 9.13425 0.953154 9.06526 0.921705 8.98934C0.890256 8.91342 0.87407 8.83204 0.87407 8.74986C0.87407 8.66768 0.890256 8.58631 0.921705 8.51038C0.953154 8.43446 0.999249 8.36547 1.05736 8.30736L8.55736 0.807361C8.61542 0.749157 8.68439 0.702979 8.76032 0.671471C8.83625 0.639963 8.91765 0.623744 8.99986 0.623744C9.08207 0.623744 9.16347 0.639963 9.2394 0.671471C9.31533 0.702979 9.3843 0.749157 9.44236 0.807361L16.9424 8.30736C17.0006 8.36542 17.0467 8.43439 17.0782 8.51032C17.1098 8.58625 17.126 8.66765 17.126 8.74986C17.126 8.83207 17.1098 8.91347 17.0782 8.9894C17.0467 9.06533 17.0006 9.1343 16.9424 9.19236V9.19236Z"
      fill="#6D39D9"
    />
  </svg>
)
